import React, { lazy } from 'react';
const photos = [{
  src: 'https://cdn.magicpatterns.com/uploads/hiWQHXmbyDgfvSmZkpQFY1/hauser1.jpg',
  alt: 'Fresh mulch beds and manicured landscaping in front of a home',
  className: 'sm:col-span-2 sm:row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pNknGe1tw3jfqrQWUbzArG/hauser4.webp',
  alt: 'Freshly mowed lawn with clean mowing stripes beside mature trees',
  className: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/a3YdAQbzBL4wXSbrtnQ88x/hauser2.jpg',
  alt: 'New landscape bed with black mulch and shrubs along a ranch home',
  className: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iSruFCiuysx5jMueZzpgDE/hauser3.webp',
  alt: 'Lush backyard lawn with a paver walkway and planting bed',
  className: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hiWQHXmbyDgfvSmZkpQFY1/hauser1.jpg',
  alt: 'Landscaped garden bed with fresh mulch around a brick home',
  className: ''
}];
export function Gallery() {
  return <section id="gallery" className="py-16 md:py-24" aria-label="Our work" data-id="element-40">
      <div className="container max-w-screen-2xl" data-id="element-41">
        <div className="text-center max-w-[800px] mx-auto mb-12" data-id="element-42">
          <p className="text-sm font-semibold uppercase tracking-widest text-primary mb-3" data-id="element-43">
            Our Work
          </p>
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4" data-id="element-44">
            See the Difference We Make
          </h2>
          <p className="text-lg text-muted-foreground" data-id="element-45">
            A look at some of the lawns, landscapes, and properties we've
            transformed across Western New York.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 auto-rows-[180px] sm:auto-rows-[200px] gap-4" data-id="element-46">
          {photos.map((photo, index) => <div key={index} className={`group relative overflow-hidden rounded-2xl shadow-sm border border-border/50 ${photo.className}`} data-id="element-47">
              <img src={photo.src} alt={photo.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-48" />
            </div>)}
        </div>
      </div>
    </section>;
}